<template>
    <div class="row mt-5 mb-5" v-if="posts.length > 0">
        <div class="col-12 col-md-6 col-lg-6" v-for="{ titulo, id, texto, enlace, imgCover } in posts" :key="id">
            <div class="card shadow">
                <div class="row g-0">
                    <div class="col-12 col-md-12 col-lg-6">
                        <div class="card-body text-start">
                            <h6 class=" text-bold">{{ titulo }}</h6>
                            <div style="height: 100%;">
                                <p class="card-text" style="margin-bottom: 20px;">{{ textFormated(texto) }}</p>
                                <a :href="enlace" target="_blank" class="button" v-if="enlace"> Ver más </a>
                            </div>

                        </div>
                    </div>
                    <div class="col-12 col-md-12 col-lg-6 column-img" style="">
                        <img :src="imgCover" class="" :alt="titulo">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        posts: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
        }
    },
    methods:{
        textFormated(text, limit = 225) {
            if (text.length > limit) text = text.slice(0, limit - 3) + "...";
          return text;
        }
    }
}
</script>

<style lang="scss" scoped>
.button {
    background-color: #b8725a !important;
    color: white;
    border-radius: 5px;
    border: 0;
    font-size: 14px;
    padding: 10px;
    width: 100%;
    text-decoration: none;
}

.card {
    height: auto;
    min-height:355px ;
}

.card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 50px;
    justify-content: space-between;
}

.column-img {
    padding-top: 0;

}

.column-img>img {
    width: 100%;
    height: 100%;
    object-fit: cover;

}

.card-text {
    font-size: 14px;
    font-weight: 300;
    color: #ADAEB4;
}

h6 {
    color: #43425D;
    font-weight: 700;
    padding-left: 0;
    margin-bottom: 25px;
}

@media only screen and (max-width: 600px) {
    .column-img>img {
        height: 150px;
        object-fit: cover;
    }

    .card {
        height: auto;
    }

    .card-body {
        height: 100%;
        padding: 10px;
    }
}

@media (min-width: 768px) and (max-width: 1024px) {

    .card {
        height: 350px;
    }

    .column-img>img {
        height: 100px;
        object-fit: cover;

    }

    .card-body {
        padding: 25px;
    }

}
</style>